import React from 'react';
export const AppChartWavePattern = ({ patternId, color, index }) => {
    return <pattern
        id={`${patternId}${index}`}
        patternUnits="userSpaceOnUse"
        key={`pattern-${index}`}
        width="73"
        height="100%"
    >
        <rect width="100%" height="100%" fill={color} />
        {[...Array(100)].map((_, i) => <svg
            key={i}
            x="0"
            y={i * 6}
            width="73"
            height="10"
            viewBox="0 -2 73 10"
            preserveAspectRatio="none"
        >
            <path d="M145.34 2.5902C144 3.4902 141.67 4.5902 139.15 4.9102C136.62 5.2302 133.9 4.7702 131.63 2.6402C129.12 0.270204 126.53 -0.249796 124.32 0.100204C122.17 0.440204 120.42 1.6102 119.43 2.6002C118.08 3.4302 115.91 4.4102 113.73 4.6902C111.54 4.9802 109.45 4.5502 108.13 2.7102C106.51 0.450204 104.13 0.000203699 101.92 0.320204C99.75 0.630204 97.66 1.6802 96.38 2.5702C95.11 3.2302 92.99 4.0302 90.75 4.2602C88.49 4.4902 86.19 4.1502 84.49 2.6402C82.5 0.870204 80.03 0.520204 77.81 0.770204C75.59 1.0202 73.56 1.8702 72.35 2.5902C71.01 3.5102 68.67 4.6102 66.14 4.9302C63.61 5.2502 60.89 4.7902 58.62 2.6602C56.12 0.270204 53.54 -0.249796 51.33 0.100204C49.18 0.440204 47.43 1.6102 46.44 2.6002C45.09 3.4302 42.92 4.4102 40.74 4.6902C38.55 4.9802 36.46 4.5502 35.14 2.7102C33.51 0.450204 31.14 0.000203699 28.93 0.320204C26.76 0.630204 24.67 1.6802 23.39 2.5702C22.12 3.2302 20 4.0302 17.76 4.2602C15.5 4.4902 13.2 4.1502 11.5 2.6402C9.51 0.860204 7.04 0.500204 4.81 0.750204C2.94 0.960204 1.22 1.6002 0 2.2202V3.3502C1.12 2.7102 2.95 1.9602 4.92 1.7402C6.97 1.5102 9.12 1.8402 10.83 3.3602C12.83 5.1402 15.46 5.4802 17.86 5.2302C20.26 4.9802 22.52 4.1402 23.87 3.4302H23.9L23.93 3.4002C25.12 2.5702 27.08 1.5802 29.08 1.3002C31.06 1.0202 33 1.4302 34.33 3.2802C35.96 5.5502 38.5 5.9802 40.88 5.6702C43.26 5.3602 45.59 4.2902 47.01 3.4102L47.06 3.3802L47.1 3.3402C47.96 2.4602 49.56 1.3902 51.49 1.0802C53.39 0.770204 55.66 1.2002 57.95 3.3602C60.49 5.7502 63.54 6.2402 66.28 5.9002C69 5.5602 71.46 4.3902 72.89 3.4102C74 2.7602 75.88 1.9702 77.92 1.7402C79.97 1.5102 82.12 1.8402 83.83 3.3602C85.83 5.1402 88.46 5.4802 90.86 5.2302C93.26 4.9802 95.52 4.1402 96.87 3.4302H96.9L96.93 3.4002C98.12 2.5702 100.08 1.5802 102.08 1.3002C104.06 1.0202 106 1.4302 107.33 3.2802C108.96 5.5502 111.5 5.9802 113.88 5.6702C116.26 5.3602 118.59 4.2902 120.01 3.4102L120.06 3.3802L120.1 3.3402C120.96 2.4602 122.56 1.3902 124.49 1.0802C126.39 0.770204 128.66 1.2002 130.95 3.3602C133.49 5.7502 136.54 6.2402 139.28 5.9002C141.69 5.6002 143.88 4.6502 145.35 3.7602V2.5902H145.34Z" stroke="#FFE1CA" fill="none" />
        </svg>)}
    </pattern>
};

export const AppChartCirclePattern = ({ patternId, color, index }) => {
    return (
        <pattern
            id={`${patternId}${index}`}
            patternUnits="userSpaceOnUse"
            width="9"
            height="9"
            key={`pattern-${index}`}
        >
            <rect width="100%" height="100%" fill={color} />
            {[...Array(10)].map((_, i) => (
                <circle
                    key={i}
                    cx={5 + i * 8}
                    cy={4}
                    r="2.41667"
                    stroke="white"
                    fill="none"
                    strokeLinejoin="round"
                />
            ))}
        </pattern>
    );
};
